<template>
<div>
    <popup-modal
        @close="confirmClose"
        position="center"
        :use-portal="false"
    >
        <div class="w-480">

            <h1 class="mb-16 text-heading-2 font-semibold" v-html="title"></h1>

            <select-dropdown
                v-model="tags"
                :add-new="canAddNew"
                allow-similar
                :auto-translate="false"
                multiple
                :options="allTags"
                searchable
                show-all-selected
                @new="createNewTag"
            />

            <div class="flex justify-end mt-16">
                <simple-button
                    :loading="working"
                    look="primary"
                    @click="handleSubmit"
                >
                    {{ $t('general.save_subject', {subject: $t('settings.tags.title')}) }}
                </simple-button>
            </div>

        </div>

    </popup-modal>

    <popup-modal-confirm
            v-if="confirmingClose"
            :message="$t('general.unsaved_changes')"
            @close="cancelClose"
            @confirm="$emit('close')"
        >
    </popup-modal-confirm>
</div>
</template>

<script>
import Loading from './Loading.vue';
import * as tags from '../../services/TagService';
import Tag from '../../models/Tag';
import { normalizeJson } from '../../../shared/helpers';
import PopupModal from './PopupModal.vue';
import SimpleButton from './SimpleButton.vue';
import SvgIcon from './SvgIcon.vue';
import Input from '../forms/Input.vue';
import PopupModalConfirm from './PopupModalConfirm.vue';
import Application from "../../models/Application";
import SelectDropdown from "../forms/SelectDropdown.vue";
import {useRepo} from "pinia-orm";

export default {
    components: {
        SelectDropdown,
        'loading': Loading,
        'popup-modal': PopupModal,
        'simple-button': SimpleButton,
        'svg-icon': SvgIcon,
        'simple-input': Input,
        'popup-modal-confirm': PopupModalConfirm,
    },
    props: {
        resourceTitle: {
            required: true,
            type: String,
        },
        currentTags: {
            default: [],
            validator: value => Array.isArray(value),
        },
        working: Boolean,
    },
    data: function () {
        return {
            fetchingTags: true,
            tags: this.currentTags.map(tag => tag.id),
            originalTags: this.currentTags.map(tag => tag.id),
            confirmingClose: false,
        }
    },
    computed: {
        title() {
            return this.$t('applications.manage_tags_for', {subject: this.subTitle});
        },
        subTitle() {
            return `<span class="block text-body-sm">${this.resourceTitle}</span>`;
        },

        allTags() {
            return useRepo(Tag).all().map(tag => {
                return {
                    value: tag.id,
                    label: tag.title,
                }
            })
        },
        canAddNew() {
            return this.$can([
                'applications.update',
                'job-applications.manage.' + this.application?.stage?.job?.id
            ]);
        },
    },
    methods: {
        handleSubmit () {
            this.$emit('update', this.tags);
        },
        confirmClose () {
            let hasChanges = this.tags.length !== this.originalTags.length
                || !this.tags.every(tag => this.originalTags.includes(tag));

            if (hasChanges) {
                this.confirmingClose = true;
            } else {
                this.$emit('close');
            }
        },
        cancelClose () {
            this.confirmingClose = false;
        },
        createNewTag (value) {
            tags.store({
                data: {
                    attributes: {
                        title: value
                    }
                }
            }).then(result => {
                return useRepo(Tag).save(normalizeJson(result));
            }).then(result => {
                let tag = result;
                // let's check if the title of the tag is already in the list, if so, we'll replace it with the id
                let index = this.tags.indexOf(tag.title);
                if (index !== -1) {
                    this.tags.splice(index, 1, tag.id);
                } else {
                    this.tags.push(tag.id);
                }
            });
        },
    },
    mounted () {
        this.fetchingTags = true;

        tags.index().then(result => {
            return useRepo(Tag).save(normalizeJson(result.data));
        }).then(inserts => {
            this.fetchingTags = false;
        });
    }
}
</script>
